module.exports = __webpack_public_path__ + "img/logo-horizontal.e7dbbdc5.png";